import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { Grid } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import { DateInput } from '../../store/inputs/DateInput';

const CDateInput = observer(({ item }: { item: DateInput }) => {
  const { label, value, onChange, disabled, error, tag, isKey, isEdit } = item;

  const isLocked = disabled || (isKey && isEdit);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Grid container spacing={3}>
        <Grid item xs={11} style={{ margin: '0 auto' }}>
          <div
            style={{
              border: error ? '1px solid #e53935' : '1px solid #e0e0e0',
              borderRadius: '10px',
              padding: '12px 16px',
              margin: '8px 0',
              background: isLocked ? '#fafafa' : '#fff',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
              <i
                className={isKey ? 'bx bx-key' : 'bx bx-calendar'}
                style={{ fontSize: '14px', color: '#757575', marginRight: '6px' }}
              />
              <span style={{ fontSize: '12px', fontWeight: 500, color: '#757575', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                {label}
              </span>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '12px' }}>
              <div style={{ flex: 1 }}>
                <KeyboardDatePicker
                  disableToolbar
                  disabled={isLocked}
                  error={!!error}
                  helperText={error}
                  format="DD/MM/YYYY"
                  margin="none"
                  id={tag}
                  label=""
                  value={value}
                  onChange={(d) => onChange(d ? new Date(d.toDate()) : null, true)}
                  onFocus={() => {}}
                  onBlur={() => {}}
                  style={{ width: '100%' }}
                  InputProps={{ style: { fontSize: '14px' } }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <KeyboardTimePicker
                  margin="none"
                  disabled={isLocked}
                  placeholder="08:00 AM"
                  label=""
                  format="hh:mm A"
                  value={value}
                  onChange={(d) => onChange(d ? new Date(d.toDate()) : null, false)}
                  KeyboardButtonProps={{ 'aria-label': 'Select time' }}
                  style={{ width: '100%' }}
                  InputProps={{ style: { fontSize: '14px' } }}
                />
              </div>
              {!isLocked && value && (
                <button
                  onClick={() => onChange(null, true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '32px',
                    height: '32px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    background: '#fafafa',
                    cursor: 'pointer',
                    flexShrink: 0,
                    outline: 'none',
                    transition: 'all 0.15s ease',
                  }}
                  title="Clear"
                >
                  <i className="bx bx-x" style={{ fontSize: '16px', color: '#9e9e9e' }} />
                </button>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
});

export default CDateInput;
